import fortress, { fortress_login } from './fortress';

export async function heartbeat(params) {
  return fortress_login.get('heartbeat', params);
}
